import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ShippingProviderAccount from 'components/ShipmentSettings/ShippingProviderAccount';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <ShippingProviderAccount />
      </SiteContent>
    </ContentLayout>
  );
};
